import { requestPaged } from '../../../lib/request-paged';
import { MINICHEF_SUBGRAPH_URL } from 'sushi/config/subgraph';
import { graphql } from '../graphql';
export const MiniChefRewardersQuery = graphql(`
query MiniChefRewarders(
  $first: Int = 1000
  $skip: Int = 0
  $where: Rewarder_filter
  $block: Block_height
) {
  rewarders(first: $first, skip: $skip, where: $where, block: $block) {
    id
    rewardToken
    rewardPerSecond
  }
}

`);
export async function getMiniChefRewarders({ chainId, ...variables }, options) {
    const url = `https://${MINICHEF_SUBGRAPH_URL[chainId]}`;
    const result = await requestPaged({
        chainId,
        url,
        query: MiniChefRewardersQuery,
        variables,
        options,
    });
    return result.rewarders.map((rewarder) => {
        // TODO: multichain id for rewardToken?
        return {
            id: rewarder.id,
            address: rewarder.rewardToken,
            rewardPerSecond: BigInt(rewarder.rewardPerSecond),
        };
    });
}
